/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class McpServerListResponse {
    getFixupPrototypeFunction() { return McpServerListResponse.fixupPrototype; }

    static newInstance(model: Partial<McpServerListResponse>): McpServerListResponse {
        let obj = Object.assign(new McpServerListResponse(), model);
        McpServerListResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<McpServerListResponse>): McpServerListResponse {
        if (!model) return null;
        return McpServerListResponse.newInstance(<McpServerListResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: McpServerListResponse) {
        if (!obj) return;

        models.McpServerListResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: McpServerListResponse): boolean {
        Object.setPrototypeOf(obj, McpServerListResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.mcp_servers) {
            for (let val of this.mcp_servers) {
                models.McpServerItem.fixupPrototype(val);
            }
        }
    }

    /**
     * Total number of servers.
     */
    total_count: number;

    /**
     * MCP Server list.
     */
    mcp_servers: Array<models.McpServerItem>;

}
